import * as React from 'react';
import { Box, Slider } from '@mui/material';

const marks = [
    { value: 70 },
    { value: 80, label: '80%' },
    { value: 90, label: '90%' },
    { value: 100, label: '100%' },
];

function valuetext(value) {
    return `${value}%`;
}

const ContributionRangeSlider = ({ value, onRangeChange }) => {

    const handleChange = (event, newValue) => {
        if (onRangeChange) {
            onRangeChange(newValue === 70 ? 100 : newValue);
        }
    };

    const getTrackColor = (value) => {
        switch (value) {
            case 70:
                return '#E0E0E0';
            case 80:
                return '#66BB6A';
            case 90:
                return '#43A047';
            case 100:
                return '#2E7D32';
            default:
                return '#00E2C7';
        }
    };

    return (
        <Box
            sx={{
                width: '99%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
            }}
        >
            <Box sx={{ width: 270 }}>
                <span style={{ fontSize: 12, fontWeight: 500 }} >
                    Value Contribution range
                </span>

                <Slider
                    aria-label="Contribution Range"
                    value={value}
                    onChange={handleChange}
                    getAriaValueText={valuetext}
                    step={10}
                    marks={marks}
                    min={70}
                    max={100}
                    valueLabelDisplay="off"
                    sx={{
                        height: 0,
                        borderRadius: 5,
                        displlay: 'flex',
                        justifyContent: 'flex-end',
                        '& .MuiSlider-thumb': {
                            height: 15,
                            width: 15,
                            backgroundColor: '#FFFFFF',
                            border: value === 0 ? '5px solid #D6F0EB' : '4px solid #00A66C',
                            boxShadow: 'none',
                            marginTop: 1.5
                        },
                        '& .MuiSlider-mark': {
                            display: 'none',
                        },
                        '& .MuiSlider-track': {
                            background: getTrackColor(value),
                            border: 'none',
                            height: 10,
                            borderRadius: 5,
                            marginTop: 1.5
                        },
                        '& .MuiSlider-rail': {
                            color: '#CEF0EA',
                            height: 10,
                            borderRadius: 5,
                            marginTop: 1.5,
                            background: `
                            repeating-linear-gradient(
                              to right,
                              #CEF0EA,
                              #CEF0EA calc(34% - 2px),
                              #FFFFFF calc(34% - 2px),
                              #FFFFFF 34%
                            )
                          `
                        },
                        '& .MuiSlider-markLabel': {
                            top: 0,
                            fontSize: 12,
                            fontWeight: 500,
                            color: "#2B2B2B"
                        },
                    }}
                />
            </Box>
        </Box>
    );
}

export default ContributionRangeSlider;


